module.exports = __webpack_public_path__ + "img/bitabout.a89941aa.jpg";